import { render, staticRenderFns } from "./DocumentLink.vue?vue&type=template&id=07157b88&scoped=true"
import script from "./DocumentLink.vue?vue&type=script&lang=js"
export * from "./DocumentLink.vue?vue&type=script&lang=js"
import style0 from "./DocumentLink.vue?vue&type=style&index=0&id=07157b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07157b88",
  null
  
)

export default component.exports